var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHelp = function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5047ff",
    d: "M12 1.999a10 10 0 1 0 10 10 10 10 0 0 0-10-10m0 15.625a1.234 1.234 0 0 1-1.25-1.25 1.213 1.213 0 0 1 1.25-1.25 1.25 1.25 0 0 1 0 2.5m2.7-5.547-1.762 1.094v.078a.938.938 0 0 1-1.875 0v-.625a.96.96 0 0 1 .469-.82l2.227-1.328a.84.84 0 0 0 .43-.742.9.9 0 0 0-.895-.859h-2a.845.845 0 0 0-.859.859.938.938 0 0 1-1.875 0 2.71 2.71 0 0 1 2.702-2.735h2a2.721 2.721 0 0 1 1.438 5.078",
    "data-name": "Group 1787"
  })));
};
export default SvgIconHelp;